import { Box, Flex, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';

export type SpotlightStatSectionProps = {
  title: string;
  text: string;
  theme?: 'light' | 'dark';
};

export function SpotlightStatSection({ title, text, theme = 'light' }: SpotlightStatSectionProps) {
  const percentage = title.trim().match(/(\d+)%/)?.[1];
  return (
    <Box
      as='section'
      bgColor={theme === 'dark' ? 'blue.800' : 'blue.100'}
      padding={{
        base: '24px 0px',
        md: '40px 0px',
      }}
    >
      <ContentContainer
        display='flex'
        alignItems={{
          md: 'center',
        }}
        flexDir={{
          base: 'column',
          md: 'row',
        }}
        gap={{
          base: 0,
          md: 8,
        }}
      >
        <Flex
          alignItems='center'
          gap={{
            base: 2,
            md: 8,
          }}
        >
          <Box flexShrink={0}>
            <PersonIconChart percentage={percentage ? Number(percentage) : 0} variant={theme} />
          </Box>
          <Heading
            as='p'
            color={theme === 'dark' ? 'accent.sky.500' : 'blue.500'}
            fontWeight='500'
            fontSize={{
              base: '3rem',
              md: '4rem',
            }}
            order={{
              base: -1,
              md: 0,
            }}
          >
            {title}
          </Heading>
        </Flex>
        <HeadingWithEmphasis
          text={text}
          emphasisProps={{
            fontWeight: '500',
            color: theme === 'dark' ? 'accent.sky.500' : 'blue.500',
          }}
          headingProps={{
            as: 'p',
            size: 'marketing-lg',
            whiteSpace: {
              xl: 'pre-wrap',
            },
            color: theme === 'dark' ? 'white' : 'black',
          }}
        />
      </ContentContainer>
    </Box>
  );
}

function PersonIconChart({ percentage, variant = 'dark' }: { percentage: number; variant?: 'light' | 'dark' }) {
  const getIcon = (v: 'light' | 'dark', isActive: boolean) => {
    switch (v) {
      default:
      case 'light':
        return `/images/person-light-${isActive ? 'active' : 'inactive'}.svg`;
      case 'dark':
        return `/images/person-dark-${isActive ? 'active' : 'inactive'}.svg`;
    }
  };

  return (
    <Box
      backgroundImage={getIcon(variant, false)}
      backgroundRepeat='round'
      display='inline-block'
      overflow='hidden'
      backgroundSize={{
        base: '23.49px 40px',
        md: '29.35px 50px',
      }}
      height={{
        base: '40px',
        md: '50px',
      }}
      width={{
        base: '234.90px',
        md: '293.50px',
      }}
    >
      <Box
        backgroundImage={getIcon(variant, true)}
        backgroundRepeat='repeat-x'
        float='left'
        width={`${percentage}%`}
        backgroundSize={{
          base: '23.49px 40px',
          md: '29.35px 50px',
        }}
        height={{
          base: '40px',
          md: '50px',
        }}
      />
    </Box>
  );
}
